import React, { memo } from 'react';
import { FormWrapper } from './Wrappers';
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';

export function isValidText(text: string) {
  return text != ''
}

const textAdapter =
  ({onChange, ...props}: {onChange: (newValue: string) => void, inputProps?: object} & Omit<OutlinedInputProps, 'onChange'>) =>
  <OutlinedInput
    {...props}
    autoComplete='off'
    onChange={(e) => { onChange(e.target.value) }}
  />

const TextInput = memo(FormWrapper({Component: textAdapter, validationFunction: isValidText}))

// Same field, no validator — for text a user may legitimately leave blank (e.g. an IBAN that the
// invoice doesn't state). Without this an empty value renders in the red error style and reads as
// required. Mirrors the required/optional split in LetterInput and PhoneInput.
export const OptionalTextInput = memo(FormWrapper({Component: textAdapter}))

export default TextInput
